<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='6'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <!--右侧开始-->
          <div class="cght_htmainrighttop">
            <div class="cght_htmainrighttopl">地址管理</div>
            <div class="cght_htmainrighttopr">
              <div class="cght_htmainrighttoprl">
                <router-link :to="{path:'/Address'}">我的收货地址</router-link>
              </div>
            </div>
          </div>
          <div class="cght_subpagemaina" v-loading="qyloading">
            <!--右边内容区域开始-->
            <ul class="cght_shdzit">
              <li class="cght_shdzw1">收货人</li>
              <li class="cght_shdzw2">收货地址</li>
              <li class="cght_shdzw3">电话</li>
              <!-- <li class="cght_shdzw4">邮编</li> -->
              <li class="cght_shdzw5">操作</li>
            </ul>
            <ul class="cght_shdzmain" v-if="addressList.length > 0">
              <li class="cght_shdzwmrdzd" v-for="(item,index) in addressList" :key="index" @mouseenter="showStyle(index)" @mouseleave="hideStyle(index)">
                <div class="cght_shdzw1">{{item.name}}</div>
                <div class="cght_shdzw2">{{item.province}}-{{item.city}}-{{item.district}}-{{item.address_detail}}</div>
                <div class="cght_shdzw3">{{item.tel}}</div>
                <div class="cght_shdzw5 cght_shdzw6" style="text-align: center;">
                  <div class="cght_shdzw5incs" style="float: none;width: auto;" :style="item.isStyle?'display: inline-block;':'display: none;'">
                    <a href="javascript:;" class="cght_shdttcxgxj" @click="showDialog(item)">修改</a>&emsp;<a href="javascript:;" @click="delAddress(item.id)">删除</a>
                  </div>
                  <em class="cght_shdzw6moren" v-show="item.is_default && item.isStyle==false">默认地址</em>
                  <a href="javascript:;" style="display: inline-block;" v-show="!item.is_default" @click="takeDefault(item)">设为默认地址</a>
                </div>
              </li>
            </ul>
            <div class="cght_shdtjxshd" v-if="addressList.length < 20">
              <a href="javascript:;" class="cght_shdttcxgxjs" @click="showDialog()">添加新地址</a>
            </div>
          </div>
          <el-dialog title="收货地址" :visible.sync="dialogFormVisible">
            <el-form :model="dataForm" ref="dataForm" :rules="rules" label-position="left" label-width="100px" style="width: 600px; margin-left:50px;">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="dataForm.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="地址" prop="district">
                <VDistpicker
                  :province="dataForm.province"
                  :city="dataForm.city"
                  :area="dataForm.district"
                  @province="onChangeProvince"
                  @city="onChangeCity"
                  @area="onChangeArea"
                ></VDistpicker>
              </el-form-item>
              <el-form-item label="详细地址" prop="address_detail">
                <el-input v-model="dataForm.address_detail" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="tel">
                <el-input v-model="dataForm.tel" autocomplete="off" maxlength="11"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="saveAddress">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import VDistpicker from 'v-distpicker'
import api from '@/api/address'

export default {
  name: 'Address',
  components: { Top, LeftNav, Bottom, VDistpicker },
  data () {
    return {
      addressList: [],
      qyloading: false,
      dataForm: {
        id: null,
        name: '',
        province: '',
        district: '',
        city: '',
        tel: '',
        address_detail: '',
        is_default: 0
      },
      dialogFormVisible: false,
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        district: [{ required: true, message: '请选择完整的收货地址', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        address_detail: [{ required: true, message: '请输入详细地址', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    this.getAddressList()
  },
  methods: {
    showStyle (index) {
      // this.addressList[index].isStyle = !this.addressList[index].isStyle
      this.$set(this.addressList[index], 'isStyle', !this.addressList[index].isStyle)
    },
    hideStyle (index) {
      this.$set(this.addressList[index], 'isStyle', !this.addressList[index].isStyle)
    },
    onChangeProvince (data) {
      this.dataForm.province = data.value
    },
    onChangeCity (data) {
      this.dataForm.city = data.value
    },
    onChangeArea (data) {
      this.dataForm.district = data.value
    },
    getAddressList () {
      this.qyloading = true
      api.getAddressList().then(res => {
        let list = res.items
        list.map(response => {
          response.isStyle = false
        })
        this.addressList = list
        this.qyloading = false
      })
    },
    delAddress (id) {
      this.$confirm('此操作将删除该地址, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delAddress({id: id}).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getAddressList()
        })
      }).catch(() => {})
    },
    takeDefault (item) {
      item.is_default = 1
      api.saveAddress(item).then((response) => {
        this.dialogFormVisible = false
        this.$message({
          type: 'success',
          message: '设置成功!'
        })
        this.getAddressList()
      })
    },
    showDialog (row) {
      if (!row) { row = {} }
      this.dialogFormVisible = true
      this.dataForm = Object.assign({}, row)
    },
    saveAddress (row) {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          api.saveAddress(this.dataForm).then((response) => {
            this.dialogFormVisible = false
            this.$notify({
              title: '收货地址',
              message: '提交成功',
              type: 'success'
            })
            this.getAddressList()
          })
        }
      })
    }
  }
}
</script>
<style scoped>
  .cght_shdzw2{
    width: 550px;
  }
</style>



// WEBPACK FOOTER //
// src/view/member/address.vue